export default "__VITE_ASSET__7lxqtDZy__"